import { useMemo, useState } from 'react';
import { Brand } from 'model/brand';

const useConnect = (brand: Brand) => {
  const [hide, setHide] = useState<boolean>(true);

  const isBrandOnline = useMemo(() => {
    return brand.integrations.every((integration) => integration.isActive);
  }, [brand.integrations]);

  return {
    hide,
    setHide,
    isBrandOnline,
  };
};

export default useConnect;
